import { render, staticRenderFns } from "./SpinWheelModal.vue?vue&type=template&id=36c2e6fc&scoped=true&"
import script from "./SpinWheelModal.vue?vue&type=script&lang=js&"
export * from "./SpinWheelModal.vue?vue&type=script&lang=js&"
import style0 from "./SpinWheelModal.vue?vue&type=style&index=0&id=36c2e6fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c2e6fc",
  null
  
)

export default component.exports